var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrashIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 11 14",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipRule: "evenodd",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.65625 9.75201c.22437 0 .40625-.18188.40625-.40625v-4.875c0-.22436-.18188-.40625-.40625-.40625s-.40625.18189-.40625.40625v4.875c0 .22437.18188.40625.40625.40625zm1.625 0c.22437 0 .40625-.18188.40625-.40625v-4.875c0-.22436-.18188-.40625-.40625-.40625s-.40625.18189-.40625.40625v4.875c0 .22437.18188.40625.40625.40625zm2.03125-.40625c0 .22437-.18188.40625-.40625.40625s-.40625-.18188-.40625-.40625v-4.875c0-.22436.18188-.40625.40625-.40625s.40625.18189.40625.40625z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.75 1.62704h-2.47813c-.19223-.946698-1.02461-1.62704-1.99062-1.62704s-1.79839.680342-1.99062 1.62704h-2.47813c-.448731 0-.8125.36376-.8125.8125 0 .44873.363769.8125.8125.8125v7.31246c0 1.3462 1.09131 2.4375 2.4375 2.4375h4.0625c1.34619 0 2.4375-1.0913 2.4375-2.4375v-7.31246c.4487 0 .8125-.36377.8125-.8125 0-.44874-.3638-.8125-.8125-.8125zm-4.46873-.812504c.51041.005294.96258.330364 1.13019.812504h-2.26038c.16761-.48214.61978-.80721 1.13019-.812504zm2.03123 10.562464c.44873 0 .8125-.3637.8125-.8125v-7.31246h-5.6875v7.31246c0 .4488.36377.8125.8125.8125z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashIcon);
export default __webpack_public_path__ + "static/media/trash-icon.443e7097.svg";
export { ForwardRef as ReactComponent };